export class PasswordResetRequestModel {
    UserName: string = '';
    FirstName: string = '';
    Email: string = '';
    RedirectUri: string = '';

}